module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg_with_quests_big.00b8bd77.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg_with_quests_big.jpg
// module id = 2894
// module chunks = 11